module.exports = "<app-menu></app-menu>\r\n\r\n"